import {Parameter} from 'platform/components';
import {NumberFormatter} from 'platform/locale';
import {match} from 'ts-pattern';

import {isNil, isNotNil} from 'ramda';

import {SourcingVehicleResponseBody} from '@dms/api/core';
import i18n from '@dms/i18n';

import {Nullish} from 'shared/web';

export const detailSecondLine = (
  formatNumber: NumberFormatter,
  vehicle: SourcingVehicleResponseBody | Nullish
): Parameter[] => {
  if (isNil(vehicle)) {
    return [];
  }

  const metricKM = i18n.t('general.metric.km');
  const metricKW = i18n.t('general.metric.kW');
  const sellerParameter = isNotNil(vehicle.seller)
    ? match<string | undefined, Parameter | null>(vehicle.seller.type?.key)
        .with('SELLERTYPE_PRIVATE_SELLER', () => ({
          icon: 'social/person',
          tooltip: vehicle.seller?.type?.translation,
        }))
        .with('SELLERTYPE_DEALERSHIP', () => ({
          icon: 'social/domain',
          tooltip: vehicle.seller?.type?.translation,
        }))
        .with('SELLERTYPE_CERTIFIED_DEALERSHIP', () => ({
          icon: 'social/domain',
          tooltip: vehicle.seller?.type?.translation,
        }))
        .with('SELLERTYPE_PARTNER_DEALERSHIP', () => ({
          icon: 'social/domain',
          tooltip: vehicle.seller?.type?.translation,
        }))
        .with('SELLERTYPE_CARVAGO', () => ({
          icon: 'social/domain',
          tooltip: vehicle.seller?.type?.translation,
        }))
        .otherwise(() => null)
    : null;

  return [
    sellerParameter,
    vehicle.year?.toString() ?? null,
    isNotNil(vehicle.power) ? `${vehicle.power} ${metricKW}` : null,
    vehicle.transmission?.translation ?? null,
    vehicle.driveType?.translation ?? null,
    vehicle.fuelType?.translation ?? null,
    vehicle.carStyle?.translation ?? null,
    isNotNil(vehicle.mileage) ? `${formatNumber(vehicle.mileage, 0)} ${metricKM}` : null,
  ].filter(isNotNil);
};
